export const loginErrorMessage =
  "There is no Innovera account that matches provided login details. Please try again or reset your password";
